import PropTypes from 'prop-types';
import { StringOrNumberType } from '.';

export default PropTypes.shape({
  id: StringOrNumberType.isRequired,
  domain_id: StringOrNumberType.isRequired,
  securityLoginDuration: StringOrNumberType.isRequired,
  securityLoginTimes: StringOrNumberType.isRequired,
  guestRequireFirstName: StringOrNumberType.isRequired,
  guestRequireLastName: StringOrNumberType.isRequired,
  guestRequireMiddleName: StringOrNumberType.isRequired,
  teamRequireFirstName: StringOrNumberType.isRequired,
  teamRequireLastName: StringOrNumberType.isRequired,
  teamRequireEmail: StringOrNumberType.isRequired,
  teamRequireMiddleName: StringOrNumberType.isRequired,
  teamRequireDOB: StringOrNumberType.isRequired,
  teamRequireStreetAddress: StringOrNumberType.isRequired,
  teamRequireCity: StringOrNumberType.isRequired,
  teamRequireState: StringOrNumberType.isRequired,
  teamRequireZip: StringOrNumberType.isRequired,
  teamRequireHomePhone: StringOrNumberType.isRequired,
  teamRequireWorkPhone: StringOrNumberType.isRequired,
  teamRequireCellPhone: StringOrNumberType.isRequired,
  teamShowWorkPhone: StringOrNumberType.isRequired,
  teamShowHomePhone: StringOrNumberType.isRequired,
  teamShowCellPhone: StringOrNumberType.isRequired,
  guestRequireEmail: StringOrNumberType.isRequired,
  guestRequireDOB: StringOrNumberType.isRequired,
  guestRequireStreetAddress: StringOrNumberType.isRequired,
  guestRequireCity: StringOrNumberType.isRequired,
  guestRequireState: StringOrNumberType.isRequired,
  guestRequireZip: StringOrNumberType.isRequired,
  guestRequireHomePhone: StringOrNumberType.isRequired,
  guestRequireWorkPhone: StringOrNumberType.isRequired,
  guestRequireCellPhone: StringOrNumberType.isRequired,
  guestShowHomePhone: StringOrNumberType.isRequired,
  guestShowWorkPhone: StringOrNumberType.isRequired,
  guestShowCellPhone: StringOrNumberType.isRequired,
  teamCustom1Show: StringOrNumberType.isRequired,
  teamCustom1Label: StringOrNumberType.isRequired,
  teamCustom1Require: StringOrNumberType.isRequired,
  teamCustom2Show: StringOrNumberType.isRequired,
  teamCustom2Label: StringOrNumberType.isRequired,
  teamCustom2Require: StringOrNumberType.isRequired,
  teamCustom3Show: StringOrNumberType.isRequired,
  teamCustom3Label: StringOrNumberType.isRequired,
  teamCustom3Require: StringOrNumberType.isRequired,
  teamCustom4Show: StringOrNumberType.isRequired,
  teamCustom4Label: StringOrNumberType.isRequired,
  teamCustom4Require: StringOrNumberType.isRequired,
  teamCustom5Show: StringOrNumberType.isRequired,
  teamCustom5Label: StringOrNumberType.isRequired,
  teamCustom5Require: StringOrNumberType.isRequired,
  guestCustom1Show: StringOrNumberType.isRequired,
  guestCustom1Label: StringOrNumberType.isRequired,
  guestCustom1Require: StringOrNumberType.isRequired,
  guestCustom2Show: StringOrNumberType.isRequired,
  guestCustom2Label: StringOrNumberType.isRequired,
  guestCustom2Require: StringOrNumberType.isRequired,
  guestCustom3Show: StringOrNumberType.isRequired,
  guestCustom3Label: StringOrNumberType.isRequired,
  guestCustom3Require: StringOrNumberType.isRequired,
  guestCustom4Show: StringOrNumberType.isRequired,
  guestCustom4Label: StringOrNumberType.isRequired,
  guestCustom4Require: StringOrNumberType.isRequired,
  guestCustom5Show: StringOrNumberType.isRequired,
  guestCustom5Label: StringOrNumberType.isRequired,
  guestCustom5Require: StringOrNumberType.isRequired,
  createVisitShowAddressSearch: StringOrNumberType.isRequired,
  createVisitShowAddressSearchRequired: StringOrNumberType.isRequired,
  createVisitShowNameSearch: StringOrNumberType.isRequired,
  createVisitShowNameSearchRequired: StringOrNumberType.isRequired,
  createVisitShowPhoneSearch: StringOrNumberType.isRequired,
  createVisitShowPhoneSearchRequired: StringOrNumberType.isRequired,
  teamRequirePosTitle: StringOrNumberType.isRequired,
  timezone: StringOrNumberType.isRequired,
  createVisitIdent1Label: StringOrNumberType.isRequired,
  createVisitIdent2Label: StringOrNumberType.isRequired,
  createVisitIdent3Label: StringOrNumberType.isRequired,
  createVisitIdent1: StringOrNumberType.isRequired,
  createVisitIdent2: StringOrNumberType.isRequired,
  createVisitIdent3: StringOrNumberType.isRequired,
  createVisitOveride1: StringOrNumberType.isRequired,
  createVisitOveride2: StringOrNumberType.isRequired,
  createVisitOveride3: StringOrNumberType.isRequired,
  createVisitShowinterviewNumShow: StringOrNumberType.isRequired,
  createVisitShowinterviewNumRequired: StringOrNumberType.isRequired,
  outreachFillLines: StringOrNumberType.isRequired,
  createVisitPrePost: StringOrNumberType.isRequired,
  guestAdditionalGDLNum: StringOrNumberType.isRequired,
  guestAdditionalGDLNumReq: StringOrNumberType.isRequired,
  guestAdditionalGDLS: StringOrNumberType.isRequired,
  guestAdditionalGDLSReq: StringOrNumberType.isRequired,
  guestAdditionalGEmployer: StringOrNumberType.isRequired,
  guestAdditionalGEmployerReq: StringOrNumberType.isRequired,
  guestAdditionalSDLNum: StringOrNumberType.isRequired,
  guestAdditionalSDLNumReq: StringOrNumberType.isRequired,
  guestAdditionalSDLS: StringOrNumberType.isRequired,
  guestAdditionalSDLSReq: StringOrNumberType.isRequired,
  guestAdditionalSEmployer: StringOrNumberType.isRequired,
  guestAdditionalSEmployerReq: StringOrNumberType.isRequired,
  guestAdditionalGender: StringOrNumberType.isRequired,
  guestAdditionalGenderReq: StringOrNumberType.isRequired,
  guestAdditionalGenderOther: StringOrNumberType.isRequired,
  guestAdditionalEducation: StringOrNumberType.isRequired,
  guestAdditionalEducationReq: StringOrNumberType.isRequired,
  guestAdditionalEducationLast: StringOrNumberType.isRequired,
  guestAdditionalEducationLastReq: StringOrNumberType.isRequired,
  guestAdditionalCounty: StringOrNumberType.isRequired,
  guestAdditionalCountyReq: StringOrNumberType.isRequired,
  guestAdditionalRace: StringOrNumberType.isRequired,
  guestAdditionalRaceReq: StringOrNumberType.isRequired,
  guestAdditionalRaceOther: StringOrNumberType.isRequired,
  guestAdditionalIncomeExpense: StringOrNumberType.isRequired,
  guestAdditionalContactHelp: StringOrNumberType.isRequired,
  guestAdditionalReasons: StringOrNumberType.isRequired,
  guestAdditionalOthersAtHome: StringOrNumberType.isRequired,
  guestAdditionalContactHelpReq: StringOrNumberType.isRequired,
  guestAdditionalReasonsReq: StringOrNumberType.isRequired,
  guestAdditionalOthersAtHomeReq: StringOrNumberType.isRequired,
  signatureRecordBy: StringOrNumberType.isRequired,
  ageGroup1: StringOrNumberType.isRequired,
  ageGroup2: StringOrNumberType.isRequired,
  ageGroup3: StringOrNumberType.isRequired,
  ageGroup4: StringOrNumberType.isRequired,
  ageGroup5: StringOrNumberType.isRequired,
  ageGroup6: StringOrNumberType.isRequired,
  ageGroup7: StringOrNumberType.isRequired,
  ageGroup8: StringOrNumberType.isRequired,
  ageGroupCount: StringOrNumberType.isRequired,
  guestAdditionalMember: StringOrNumberType.isRequired,
  reservationShowEmail: StringOrNumberType.isRequired,
  reservationRequireEmail: StringOrNumberType.isRequired,
  reservationShowHouseholdTotal: StringOrNumberType.isRequired,
  reservationRequireHouseholdTotal: StringOrNumberType.isRequired,
  reservationShowAddress: StringOrNumberType.isRequired,
  reservationRequireStreetAddress: StringOrNumberType.isRequired,
  reservationRequireCity: StringOrNumberType.isRequired,
  reservationRequireState: StringOrNumberType.isRequired,
  reservationRequireZip: StringOrNumberType.isRequired,
  reservationShowCounty: StringOrNumberType.isRequired,
  reservationRequireCounty: StringOrNumberType.isRequired,
  reservationRequireHomePhone: StringOrNumberType.isRequired,
  reservationRequireWorkPhone: StringOrNumberType.isRequired,
  reservationRequireCellPhone: StringOrNumberType.isRequired,
  reservationShowHomePhone: StringOrNumberType.isRequired,
  reservationShowWorkPhone: StringOrNumberType.isRequired,
  reservationShowCellPhone: StringOrNumberType.isRequired,
  reservationShowVolunteer: StringOrNumberType.isRequired,
  reservationRequireVolunteer: StringOrNumberType.isRequired,
  reservationShowNote: StringOrNumberType.isRequired,
  barcode: StringOrNumberType.isRequired,
  guestAdditionalLocation: StringOrNumberType.isRequired,
  guestAdditionalMailingAddress: StringOrNumberType.isRequired,
  dbVersion: StringOrNumberType.isRequired,
  siteTitle: StringOrNumberType.isRequired,
  siteTitleImage: StringOrNumberType.isRequired,
  createVisitShowSignature: StringOrNumberType.isRequired,
  createVisitPreCheckID: StringOrNumberType.isRequired,
  createVisitPreCheckHelp: StringOrNumberType.isRequired,
  createVisitDefaultPanel: StringOrNumberType.isRequired,
  createVisitRedirect: StringOrNumberType.isRequired,
  createVisitFocus: StringOrNumberType.isRequired,
  income1Status: StringOrNumberType.isRequired,
  income1Label: StringOrNumberType.isRequired,
  income2Status: StringOrNumberType.isRequired,
  income2Label: StringOrNumberType.isRequired,
  income3Status: StringOrNumberType.isRequired,
  income3Label: StringOrNumberType.isRequired,
  income4Status: StringOrNumberType.isRequired,
  income4Label: StringOrNumberType.isRequired,
  income5Status: StringOrNumberType.isRequired,
  income5Label: StringOrNumberType.isRequired,
  income6Status: StringOrNumberType.isRequired,
  income6Label: StringOrNumberType.isRequired,
  income7Status: StringOrNumberType.isRequired,
  income7Label: StringOrNumberType.isRequired,
  income8Status: StringOrNumberType.isRequired,
  income8Label: StringOrNumberType.isRequired,
  income9Status: StringOrNumberType.isRequired,
  income9Label: StringOrNumberType.isRequired,
  income10Status: StringOrNumberType.isRequired,
  income10Label: StringOrNumberType.isRequired,
  expense1Status: StringOrNumberType.isRequired,
  expense1Label: StringOrNumberType.isRequired,
  expense2Status: StringOrNumberType.isRequired,
  expense2Label: StringOrNumberType.isRequired,
  expense3Status: StringOrNumberType.isRequired,
  expense3Label: StringOrNumberType.isRequired,
  expense4Status: StringOrNumberType.isRequired,
  expense4Label: StringOrNumberType.isRequired,
  expense5Status: StringOrNumberType.isRequired,
  expense5Label: StringOrNumberType.isRequired,
  expense6Status: StringOrNumberType.isRequired,
  expense6Label: StringOrNumberType.isRequired,
  expense7Status: StringOrNumberType.isRequired,
  expense7Label: StringOrNumberType.isRequired,
  expense8Status: StringOrNumberType.isRequired,
  expense8Label: StringOrNumberType.isRequired,
  expense9Status: StringOrNumberType.isRequired,
  expense9Label: StringOrNumberType.isRequired,
  expense10Status: StringOrNumberType.isRequired,
  expense10Label: StringOrNumberType.isRequired,
  guestIncomeExpenseColumns: StringOrNumberType.isRequired,
  guestIncomeExpenseColumnsChange: StringOrNumberType.isRequired,
  cvsearch2: StringOrNumberType.isRequired,
  visitColorActive: StringOrNumberType.isRequired,
  visitColorOptions: StringOrNumberType.isRequired,
  fiscalMonth: StringOrNumberType.isRequired,
  fiscalDay: StringOrNumberType.isRequired,
  guestSpouse: StringOrNumberType.isRequired,
  guestMaritalStatus: StringOrNumberType.isRequired,
  guestLanguage: StringOrNumberType.isRequired,
  guestOtherRelReq: StringOrNumberType.isRequired,
  guestOtherAgeReq: StringOrNumberType.isRequired,
  guestOtherAgeHH: StringOrNumberType.isRequired,
  ageGroup9: StringOrNumberType.isRequired,
  visitPrint: StringOrNumberType.isRequired,
  terms: StringOrNumberType.isRequired,
  termsStatus: StringOrNumberType.isRequired,
  hasSigLock: StringOrNumberType.isRequired,
  sigLock: StringOrNumberType.isRequired,
  signatureRecordByTime: StringOrNumberType.isRequired,
  editGuest: StringOrNumberType.isRequired,
  editGuestByInt: StringOrNumberType.isRequired,
  editGuestByIntType: StringOrNumberType.isRequired,
  editGuestByType: StringOrNumberType.isRequired,
  editGuestByDate: StringOrNumberType
});
